// extracted by mini-css-extract-plugin
export default {"container":"ErrorAlert_container__zcNvB"};